export const FEEDBACK_SURVEY_OPTIONS = {
  NO_LONGER_INTERESTED: 'NO_LONGER_INTERESTED',
  DID_NOT_SIGN_UP: 'DID_NOT_SIGN_UP',
  TOO_MANY_EMAILS: 'TOO_MANY_EMAILS',
  IRRELEVANT_CONTENT: 'IRRELEVANT_CONTENT',
  OTHER: 'OTHER'
};
export const OTHER_REASON_ERRORS = {
  TOO_LONG: 'TOO_LONG',
  REQUIRED: 'REQUIRED'
};
export const BREAKPOINTS = {
  mobile: '0px',
  tablet: '600px',
  desktop: '960px',
  desktopL: '1280px',
  desktopXL: '1920px'
};